<template>
  <div class="apps-container">
    <iw-scrollbar
      wrap-class="scrollbar-wrapper"
      :wrap-style="'height:' + height + 'px;'"
    >
      <ul>
        <li
          v-for="app in apps
            .filter((item) => item.id !== '999' && !item.special)
            .filter((item) => !item.path.startsWith('/gpt'))
            .slice(0, max)"
          :key="app.id"
          :class="getCls(app.path)"
        >
          <AppLink :item="app">
            <iw-popover
              :key="app.title"
              placement="right"
              trigger="hover"
              show-arrow
              popper-class="chimi-logo-menu"
            >
              <div slot="reference">
                <div class="icon">
                  <svg-icon
                    class-name="sidebar-icon"
                    :icon-class="getIcon(app)"
                  />
                </div>
                <div class="label">
                  <span>
                    {{ app.title }}
                  </span>
                </div>
              </div>
              <div class="label">
                <span>
                  {{ app.title }}
                </span>
              </div>
            </iw-popover>
          </AppLink>
        </li>
        <li v-if="apps.length > max">
          <iw-popover
            v-model="visible"
            placement="rightTop"
            show-arrow
            popper-class="sidebar-menu"
          >
            <i
              slot="reference"
              class="iw-icon-more"
              style="padding: 0 15px"
              :class="{ active: getActive(apps.slice(max)) }"
              @mouseenter="visible = true"
              @mouseleave="timeoutFn(false)"
            />
            <iw-scrollbar :wrap-style="'height:' + (268 + 16) + 'px;'">
              <ul @mouseenter="timeoutFn(true)" @mouseleave="timeoutFn(false)">
                <li
                  v-for="app in apps
                    .filter((item) => item.id !== '999')
                    .filter((item) => !item.path.startsWith('/gpt'))
                    .slice(max)"
                  :key="app.id"
                  :class="getCls(app.path)"
                  :style="{
                    'align-items': ['en'].includes(language)
                      ? 'flex-start'
                      : 'center',
                  }"
                  @click="linkClick"
                >
                  <AppLink :item="app">
                    <iw-popover
                      :key="app.title"
                      placement="right"
                      trigger="hover"
                      show-arrow
                      popper-class="chimi-logo-menu chimi-logo-menu2"
                    >
                      <span slot="reference" class="chimi-logo-menu-predisplay">
                        <span class="icon">
                          <svg-icon
                            class-name="sidebar-icon"
                            :icon-class="getIcon(app, 'popup')"
                          />
                        </span>
                        <span class="label">{{ app.title }}</span>
                      </span>
                      <span
                        class="chimi-logo-item-label"
                        @mouseenter="timeoutFn(true)"
                        @mouseleave="timeoutFn(false)"
                        >{{ app.title }}</span
                      >
                    </iw-popover>
                  </AppLink>
                </li>
              </ul>
            </iw-scrollbar>
          </iw-popover>
        </li>
      </ul>
    </iw-scrollbar>
    <div class="chimi-logo">
      <template v-for="item in $t('chimiLogoData')">
        <iw-popover
          :key="item.value"
          placement="right"
          trigger="hover"
          show-arrow
          popper-class="chimi-logo-menu"
        >
          <a
            slot="reference"
            :href="item.href"
            target="_blank"
            class="chimi-logo-item"
          >
            <span class="chimi-logo-item-icon">
              <svg-icon class-name="sidebar-icon" :icon-class="item.value" />
            </span>
          </a>
          <span class="chimi-logo-item-label">{{ item.label }}</span>
        </iw-popover>
      </template>
    </div>
    <SideFooter @panelChange="panelChange" />
  </div>
</template>

<script>
import SideFooter from "./footer";
import AppLink from "./link";
import { parseUrl } from "@/utils/helper";
import { debounce } from "lodash";
import { mapState } from "vuex";
const defaultMaxNumber = 9;
export default {
  components: {
    SideFooter,
    AppLink,
  },
  props: {
    apps: {
      type: Array,
    },
  },
  data() {
    return {
      max: defaultMaxNumber,
      height: this.calcHeight(),
      visible: false,
    };
  },
  computed: {
    ...mapState("app", ["language"]),
  },
  mounted() {
    window.addEventListener("resize", this.resize);
    this.resize();
  },
  methods: {
    timeoutFn: debounce(function (bl) {
      this.visible = bl;
    }, 150),
    resize() {
      this.height = this.calcHeight();
      const max = parseInt((this.height - 60) / 60);
      this.max = Math.min(max, defaultMaxNumber);
    },
    calcHeight() {
      return document.body.clientHeight - 60 - 147;
    },
    getCls(path) {
      let routePath = this.$route.path.split("/").slice(0, 2).join("/");

      if (path.indexOf("product") > -1) {
        const urls = parseUrl(path);
        path = decodeURIComponent(urls.query.product);
      }
      if (this.$route.query.product) {
        routePath = decodeURIComponent(this.$route.query.product);
      }
      if (path === routePath) {
        return { active: true };
      }
    },
    getIcon({ id, path }, type) {
      if (this.getCls(path)) {
        return type === "popup" ? `appid-${id}-3` : `appid-${id}`;
      }
      return type === "popup" ? `appid-${id}-2` : `appid-${id}-1`;
    },
    getActive(apps) {
      return apps.find((item) => {
        let path = item.path;
        if (this.getCls(path)) {
          return true;
        }
      });
    },
    panelChange(value) {
      this.$emit("panelChange", value);
    },
    linkClick() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.apps-container {
  width: 56px;
  border-radius: 0 8px 8px 0;
  background-color: rgba(255, 255, 255, 0.4);
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  overflow: hidden;
  .sidebar-logo {
    width: 56px;
    height: 60px;
    padding: 4px;
  }
  ul {
    display: flex;
    flex-direction: column;

    /deep/ li {
      list-style: none;
      height: 60px;
      width: 56px;
      text-align: center;
      color: $textColor;
      cursor: pointer;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        background-color: #eaeff6;
      }
      &:last-child {
        background-color: transparent;
      }
      &.active a {
        font-weight: 600;
        color: $textActiveColor;
      }
      span {
        a {
          width: 56px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          color: $textColor;
          &.router-link-active {
            color: $textActiveColor;
          }
        }
      }
      .icon {
        height: 24px;
      }
      .label {
        font-size: 12px;
        text-align: center;
        margin-top: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 4px;
        > span {
          width: calc(100%);
          display: inline-block;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          line-height: 14px;
        }
      }
      .sidebar-icon {
        width: 24px;
        height: 24px;
      }
      .iw-icon-more {
        font-size: 20px;
        opacity: 0.5;
        &.active {
          color: $textActiveColor;
        }
      }
    }
  }
  .chimi-logo {
    position: absolute;
    bottom: 40px;
    display: flex;
    flex-direction: column;
    &-item {
      display: flex;
      width: 56px;
      height: 40px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: $textColor;
      white-space: nowrap;
      cursor: pointer;
      &:hover {
        color: $textHoverColor;
      }
      &-icon {
        margin-bottom: 2px;
        > svg {
          width: 18px;
          height: 18px;
        }
      }
      &-label {
        font-size: 12px;
      }
    }
  }
}
</style>
